module.exports = __webpack_public_path__ + "img/KSC08938.1278b877.jpg";